import { handleGqlResponseBody } from "@/utils/apollo.util";
import { GET_CHANNEX_STATUS_QUERY } from "@/graphql/queries/configuration/channex/get-channex-status.query";
import { GET_CHANNEX_MAPPINGS_QUERY } from "@/graphql/queries/configuration/channex/get-channex-mappings.query";
import { GET_CHANNEX_REMOTE_OPTIONS_QUERY } from "@/graphql/queries/configuration/channex/get-channex-remote-options.query";
import { TEST_CHANNEX_CONNECTION_QUERY } from "@/graphql/queries/configuration/channex/test-channex-connection.query";
import { UPDATE_CHANNEX_MAPPINGS_MUTATION } from "@/graphql/mutations/configuration/channex/update-channex-mappings.mutation";
import { SET_CHANNEX_ENABLED_MUTATION } from "@/graphql/mutations/configuration/channex/set-channex-enabled.mutation";
import { REGISTER_CHANNEX_WEBHOOK_MUTATION } from "@/graphql/mutations/configuration/channex/register-channex-webhook.mutation";
import { TRIGGER_CHANNEX_FULL_SYNC_MUTATION } from "@/graphql/mutations/configuration/channex/trigger-channex-full-sync.mutation";
import { SYNC_CHANNEX_STRUCTURE_MUTATION } from "@/graphql/mutations/configuration/channex/sync-channex-structure.mutation";

const channex = {
  actions: {
    async getChannexStatusQuery() {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_CHANNEX_STATUS_QUERY,
          fetchPolicy: "no-cache",
        });
      });
    },
    async getChannexMappingsQuery() {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_CHANNEX_MAPPINGS_QUERY,
          fetchPolicy: "no-cache",
        });
      });
    },
    async getChannexRemoteOptionsQuery() {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_CHANNEX_REMOTE_OPTIONS_QUERY,
          fetchPolicy: "no-cache",
        });
      });
    },
    async testChannexConnectionQuery() {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: TEST_CHANNEX_CONNECTION_QUERY,
          fetchPolicy: "no-cache",
        });
      });
    },
    async updateChannexMappingsMutation({ commit }, { roomTypes, ratePlans }) {
      return await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: UPDATE_CHANNEX_MAPPINGS_MUTATION,
          variables: {
            roomTypes,
            ratePlans,
          },
        });
      });
    },
    async setChannexEnabledMutation({ commit }, { enabled }) {
      return await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: SET_CHANNEX_ENABLED_MUTATION,
          variables: {
            enabled,
          },
        });
      });
    },
    async registerChannexWebhookMutation() {
      return await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: REGISTER_CHANNEX_WEBHOOK_MUTATION,
        });
      });
    },
    async triggerChannexFullSyncMutation() {
      return await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: TRIGGER_CHANNEX_FULL_SYNC_MUTATION,
        });
      });
    },
    async syncChannexStructureMutation() {
      return await handleGqlResponseBody(({ mutation }) => {
        return mutation({
          mutation: SYNC_CHANNEX_STRUCTURE_MUTATION,
        });
      });
    },
  },
};

export default channex;
